import styled from "styled-components";

export const Container = styled.div`
  height: 500px;
  width: 900px;
  background-color: ${(props) => props.theme.white};
  max-height: 90%;
  max-width: 90%;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
`;

export const Image = styled.img`
  height: 110px;
  width: 110px;
  margin-bottom: 30px;
  object-fit: contain;
`;

export const Title = styled.h1`
  color: ${(props) => props.theme.brightTurquoise};
  font-family: Nunito;
  font-size: 45px;
  font-weight: 800;
`;

export const Subtitle = styled.h3`
  color: ${(props) => props.theme.tuatara};
  font-family: Roboto;
  font-size: 23px;
  line-height: 40px;
  font-weight: 300;
  padding: 0px 20px;
  text-align: center;
  max-width: 540px;
`;
export const BottomButtonContainer = styled.div`
  height: 85px;
  width: 100%;
  border-top: 1px solid ${(props) => props.theme.brightTurquoise};
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Button = styled.button`
  width: 215px;
  height: 49px;
  border-radius: 24px;
  background-color: transparent;
  border: 1px solid ${(props) => props.theme.brightTurquoise};
  color: ${(props) => props.theme.brightTurquoise};
  font-family: Nunito;
  font-size: 17px;
  font-weight: 800;
  outline: none;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }

  ${(props) => props.theme.smartphone} {
    width: 170px;
    height: 40px;
    border-radius: 18px;
    font-size: 13px;
  }
`;
